import { render, staticRenderFns } from "./InvitedOrganizations.vue?vue&type=template&id=35d78652&"
import script from "./InvitedOrganizations.vue?vue&type=script&lang=js&"
export * from "./InvitedOrganizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports